import _t from 'i18n!nls/unified-common';

export const getPathwayDisclaimer = () => {
  return _t(
    '¹ Median salary and job opening data are sourced from United States Lightcast™ Job Postings Report. Data for job roles relevant to featured programs (3/1/2023 - 3/1/2024)'
  );
};

export const getXdpCareerImprovementPercentageDisclaimer = () => {
  return _t(
    '² Positive career outcome (e.g., new job, promotion, or raise) within six months of completion. Based on program graduate survey, United States 2022.'
  );
};
